// Native <details class="dropdown"> panels toggle on their <summary> but have no
// built-in outside-click dismissal, so an opened dropdown (e.g. "Add monitor")
// stays open until its summary is clicked again. Progressively enhance every such
// dropdown to close on an outside click or the Escape key. Without JS the
// disclosure still opens and closes from the summary, so the baseline is intact.

// Close any open dropdown that does not contain the given node.
function closeDropdownsExcept(node) {
  for (const dropdown of document.querySelectorAll('details.dropdown[open]')) {
    if (!dropdown.contains(node)) {
      dropdown.removeAttribute('open')
    }
  }
}

document.addEventListener('click', (event) => {
  closeDropdownsExcept(event.target)
})

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return
  const open = document.querySelector('details.dropdown[open]')
  if (!open) return
  open.removeAttribute('open')
  // Return focus to the trigger so keyboard users keep their place.
  open.querySelector('summary')?.focus()
})
